<template>
    <div class="finish-alarm-detail">
        <div class="bnt"><el-button @click="backList()">返回</el-button></div>

        <div class="container">
            <div class="left-box">
                <div class="title">报警详情</div>
                <div class="left-box-center">
                    <alarm-detail-box :alarm-detail-data="alarmData"></alarm-detail-box>
                </div>
            </div>
            <div class="right-box">
                <webSock :groupId="alarmId" ref="webSock" :size="10" :height="500"></webSock>
            </div>
        </div>

    </div>
</template>

<script>
    import AlarmDetailBox from '../alarm-detail-box/alarm-detail-box'
    import {listAPI} from '@/api-path/command-center.js'
    export default {
        name: "finish-alarm-detail",
        components: {
            AlarmDetailBox
        },
        props: {alarmId: {type: String}},
        data() {
            return {
                alarmData: {
                    src: 'https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2057588226,2402156864&fm=11&gp=0.jpg',
                },
                showHistory: true,
            }
        },
        created () {
            this.getAlarmDetail()
        },
        methods: {
            getAlarmDetail() {
                this.$http.get(listAPI.datail + '?alarmId=' + this.alarmId).then(res => {
                    this.dialogVisible = true
                    res.result.handlers.map(item => {
                        item.isOpen = false
                    })
                    this.alarmData = res.result
					if(res.result.status==3||res.result.status==8||res.result.status==9){
						this.$store.commit('setIsForbidden',true)
					}
                })
            },
            backList() {
                this.$emit('back')

            }
        }

    }
</script>

<style scoped lang="less">
@import "alarm-detail-im";
</style>
